/// <reference path="../../../teva/selectbox/selectbox.ts" />
/// <reference path="../../../teva/dropdown/dropdown.ts" />
/// <reference path="../../../teva/infinitescroll/infinitescroll.ts" />
/// <reference path="../../../teva/datepicker/datepicker.ts" />
/// <reference path="../../../teva/navigation/navigation.ts" />
/// <reference path="../../common/modals/modals.ts" />
/// <reference path="../../common/navigation/navigation.ts" />
/// <reference path="../main/main.ts" />
/// <reference path="../propertypicker/propertypicker.ts" />

namespace OfficeGuy.CRM {
    declare var google;

    export class Charts {
        static InitGoogleCharts(Callback) {
            if (typeof (google) == "undefined" || typeof (google.charts) == "undefined") {
                $.getScript('https://www.gstatic.com/charts/loader.js', function () {
                    Callback();
                });
            }
            else
                Callback();
        }
        static InitChart(ContainerSelector, Data, ChartType, Options?) {
            if (Common.IsMobileDevice()) {
                var AnnotationIndex = -1;
                for (var i = 0; i < Data[0].length; i++)
                    if (Data[0][i] && Data[0][i].role == 'annotation')
                        AnnotationIndex = i;
                if (AnnotationIndex != -1) {
                    for (var i = 0; i < Data.length; i++)
                        Data[i].splice(AnnotationIndex, 1);
                }
            }
            Charts.InitGoogleCharts(function () {
                google.charts.load('current', {
                    packages: ['corechart', 'line']
                });
                google.charts.setOnLoadCallback(function () {
                    Charts.Graph_Draw(ContainerSelector, Data, ChartType, Options);
                });
            });
        }

        static Graph_Draw(ContainerSelector, Data, ChartType, Options?) {
            var Defaults = {
                fontName: 'PingHL',
                reverseCategories: true,
                width: '100%',
                height: 500,
                chartArea: {
                    left: ChartType == 'Pie' ? 10 : 100,
                    top: 10,
                    width: ChartType == 'SteppedAreaChart' ? '80%' : '100%',
                    height: '80%'
                },
                annotations: {
                    textStyle: {
                        //fontSize: 10,
                        color: "1F213A"
                    },
                    //style: "line"
                },
                backgroundColor: "transparent",
                sliceVisibilityThreshold: 0,
                colors: [
                    '#ADCCEB', // 5
                    '#CCADEB', // 7
                    '#EBADD5', // 9
                    '#F6D9BC', // 11
                    '#CCEBAD', // 1
                    '#ADEBCC', // 3

                    '#ADADEB', // 6
                    '#EBADEB', // 8
                    '#F6F6BC', // 10
                    '#F6BCBC', // 12
                    '#ADEBAD', // 2
                    '#ADEBEB', // 4

                ],
                tooltip: {
                    isHtml: true
                },
                pieSliceTextStyle: {
                    color: '#1F213A',
                    fontSize: 14
                },
                legend: {
                    position: "bottom",
                },
                hAxis: {
                    minValue: 0
                },
                vAxis: {
                    minValue: 0
                }
            };
            Options = $.extend(Defaults, Options);

            var Container = $(ContainerSelector)[0];
            var Chart = new google.visualization.ColumnChart(Container);
            if (ChartType == 'Columns')
                Chart = new google.visualization.ColumnChart(Container);
            else if (ChartType == 'Pie')
                Chart = new google.visualization.PieChart(Container);
            else if (ChartType == 'SteppedAreaChart')
                Chart = new google.visualization.SteppedAreaChart(Container);
            else
                Chart = new google.visualization.LineChart(Container);
            var DataTable = google.visualization.arrayToDataTable(Data);
            Chart.draw(DataTable, Options);

            var ResizeEvent = function () {
                if ($(ContainerSelector).length == 0)
                    $(window).off("resize", ResizeEvent);
                else
                    Chart.draw(DataTable, Options);
            };
            $(window).on("resize", ResizeEvent);
        }
    }
}
